import { appRoutes } from './routes';
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import IndexLayout from '../layouts';
import NotFoundPage from '../views/404';
import LoginScreen from '../containers/AuthContainer/LoginContainer';
import RegisterScreen from '../views/Auth/signup/';
import ForgotPasswordScreen from '../views/Auth/forgotPassword';
import VerifyEmailScreen from '../views/Auth/verifyEmail';
import DashboardScreen from '../containers/DashboardContainer';
import TimeAttendance from './../views/UserAttendance/TimeAttendance';
import { SettingsPage } from '../views/Settings/index';
import TeamAttendance from '../containers/TeamAttendance';
// import ProjectContainer from '../containers/ProjectContainer';
import ManageTasks from './../views/Tasks/index';
import { ProfilePage } from './../views/Profile/index';
// import TeamInvite from '../views/Teams/invite/index';
import { RegularizationPage } from './../views/Regulation';
import InvitationPage from './../views/Invitation/index';
import AddCompany from './../views/Company/AddCompany/index';
import SelectCompany from './../views/Company/SelectCompany/index';
import Invite from '../views/Invitees/Invite';
import AddUpdateTaskPage from '../views/TaskPage/AddUpdateTaskPage';
import { LeavePage } from '../views/Leave';
import { LeaveRequestPage } from '../views/LeaveRequest';
import ApplicationDashboard from '../views/ApplicationDashboard/applicationDashboard';
import ApplicationDashboardInternal from '../views/ApplicationDashboard/applicationDashboardInternal';
import PerformanceDashboard from '../views/V2/PerformanceDashboard';
import ActivityLog from '../views/V2/ActivityLog';
import TeamsTimelinePage from '../views/TeamsTimeline';
import UsersDataContainer from '../containers/UsersDataContainer';
import { ScreenshotsPage } from '../views/Screenshots';
// NEW: Import subscription components
import SubscriptionSuspendedPage from '../views/SubscriptionSuspended';
import SubscriptionPage from '../views/Subscription';
import InvoicesPage from '../views/Invoices';
import { AlertsPage } from '../views/Alerts';
import { CreateEmployeesPage } from '../views/CreateEmployees';
import { EmployeeListPage } from '../views/EmployeeList';
import { TeamListPage } from '../views/TeamList';
import { InvitationsHubPage } from '../views/InvitationsHub';
import { DownloadDesktopAppPage } from '../views/DownloadDesktopApp';
import {
  IntegrationsPage,
  QuickBooksDetailPage,
  SalesforceDetailPage,
  KekaDetailPage,
  JiraDetailPage,
  SageHRDetailPage,
  ZohoPeopleDetailPage,
} from '../views/Integrations';
import { TeamsReporting } from '@/views/TeamsReporting';
import { TimelinePage } from '@/views/Timeline';
import { UserAttendancePage } from '@/views/UserAttendance';
import { AppUsagePage } from '@/views/AppUsage';
import { AddTaskPage } from '@/views/AddTask';
import { InviteesListPage } from '@/views/Invitees';
import { TeamsTimelineComponent } from '@/views/TeamsTimeline/TeamsTimeline.component';
import { ProjectPage } from '@/views/Projects';
import { RegularizationRequestsPage } from '@/views/RegularizationRequests';
import { DashboardOverviewPage } from '@/views/DashboardOverview';
import { DashboardOverviewNewPage } from '@/views/DashboardOverviewNew';
import { TeamDashboardPage } from '@/views/TeamDashboard';
import { NotificationsPage } from '@/views/Notifications/index';
import { OnboardingPage } from '@/views/Onboarding';
import { moduleIds, useFeatures } from '@/hooks/useFeatures';
import { useSelector } from 'react-redux';
import { CheckEmailPage } from '@/views/CheckEmail';

const RedirectFromLegacyIndividualDashboard = () => (
  <Redirect to={appRoutes().dashboardOverview} />
);

const RedirectToDashboardNew = () => (
  <Redirect to={appRoutes().dashboardOverviewNew} />
);

export const routesData = [
  {
    path: appRoutes().login,
    exact: true,
    name: 'Login',
    hidden: true,
    component: LoginScreen,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().signup,
    exact: true,
    name: 'Login',
    hidden: true,
    component: RegisterScreen,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  // NEW: Subscription routes
  {
    path: appRoutes().subscriptionSuspended,
    exact: true,
    name: 'Subscription Suspended',
    hidden: true,
    component: SubscriptionSuspendedPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().subscription,
    exact: true,
    name: 'Subscription Plans',
    hidden: true,
    component: SubscriptionPage,
    authorizedFor: ['Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().payment,
    exact: true,
    name: 'Payment',
    hidden: true,
    component: () => <div>Payment Page - To be implemented</div>,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().invoices,
    exact: true,
    name: 'Invoices',
    icon: 'ni ni-archive-2 text-primary',
    component: InvoicesPage,
    authorizedFor: ['Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().alerts,
    moduleId: moduleIds.PRODUCTIVITY_ALERT,
    exact: true,
    name: 'Alerts',
    icon: 'ni ni-notification-70 text-primary',
    component: AlertsPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },

  {
    path: appRoutes().forgotPassword,
    exact: true,
    name: 'Forgot Password',
    hidden: true,
    component: ForgotPasswordScreen,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().verifyEmail,
    exact: true,
    name: 'Verify Email',
    hidden: true,
    component: VerifyEmailScreen,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().invitation,
    moduleId: moduleIds.INVITATIONS,
    name: 'Invitation',
    icon: 'ni ni-tv-2 text-primary',
    component: InvitationPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },

  {
    path: appRoutes().userAttendance,
    moduleId: moduleIds.USER_ATTENDANCE,
    exact: true,
    name: 'User Attendance',
    icon: 'ni ni-tv-2 text-primary',
    component: UserAttendancePage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().addCompany,
    exact: true,
    name: 'Add Company',
    hidden: true,
    component: AddCompany,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().selectCompany,
    exact: true,
    name: 'Select Company',
    hidden: true,
    component: SelectCompany,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },

  {
    path: appRoutes().timeline,
    moduleId: moduleIds.TIMELINE,
    exact: true,
    name: 'Timeline',
    icon: 'ni ni-time-alarm text-primary',
    component: TimelinePage,
    authorizedFor: ['Member', 'Manager'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().notifications,
    moduleId: moduleIds.NOTIFICATIONS,
    exact: true,
    name: 'Notifications',
    icon: 'ni ni-time-alarm text-primary',
    component: NotificationsPage,
    authorizedFor: ['Member', 'Manager'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().screenshots,
    moduleId: moduleIds.SCREENSHOTS,
    exact: true,
    name: 'Screenshots',
    icon: 'ni ni-image text-primary',
    component: ScreenshotsPage,
    authorizedFor: ['Member', 'Manager'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().appUsage,
    moduleId: moduleIds.APP_USAGE,
    exact: true,
    name: 'App Usage',
    icon: 'ni ni-app text-primary',
    component: AppUsagePage,
    authorizedFor: ['Member', 'Manager'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().teamsTimeline,
    moduleId: moduleIds.TEAMS_TIMELINE,
    exact: true,
    name: "Team's Timeline",
    icon: 'ni ni-time-alarm text-primary',
    component: TeamsTimelineComponent,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().teamsReporting,
    moduleId: moduleIds.TEAMS_REPORTING,
    exact: true,
    name: "Team's Reporting",
    icon: 'ni ni-time-alarm text-primary',
    component: TeamsReporting,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().usersData,
    exact: true,
    name: 'Users Data',
    icon: 'ni ni-time-alarm text-primary',
    component: UsersDataContainer,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().manageSettings,
    moduleId: moduleIds.SETTINGS,
    exact: true,
    name: 'Settings',
    icon: 'ni ni-tv-2 text-primary',
    component: SettingsPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: true,
  },
  {
    path: appRoutes().teamAttendance,
    moduleId: moduleIds.TEAM_ATTENDANCE,
    exact: true,
    name: 'Team Attendance',
    icon: 'ni ni-tv-2 text-primary',
    component: TeamAttendance,
    authorizedFor: ['Manager'],
    hasSortingOptions: true,
  },
  {
    path: appRoutes().addEmployee,
    moduleId: moduleIds.ADD_EMPLOYEE,
    exact: true,
    name: 'Add Employee',
    icon: 'ni ni-tv-2 text-primary',
    component: CreateEmployeesPage,
    authorizedFor: ['Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().employeeList,
    moduleId: moduleIds.EMPLOYEE_LIST,
    exact: true,
    name: 'Employee List',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployeeListPage,
    authorizedFor: ['Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().teamList,
    moduleId: moduleIds.TEAM_LIST,
    exact: true,
    name: 'Team List',
    icon: 'ni ni-tv-2 text-primary',
    component: TeamListPage,
    authorizedFor: ['Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().invitationsHub,
    exact: true,
    name: 'Invitations',
    icon: 'ni ni-tv-2 text-primary',
    component: InvitationsHubPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().integrations,
    exact: true,
    name: 'Integrations',
    icon: 'ni ni-settings text-primary',
    component: IntegrationsPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().integrationsQuickBooks,
    exact: true,
    name: 'QuickBooks Integration',
    icon: 'ni ni-settings text-primary',
    component: QuickBooksDetailPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().integrationsSalesforce,
    exact: true,
    name: 'Salesforce Integration',
    icon: 'ni ni-settings text-primary',
    component: SalesforceDetailPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().integrationsKeka,
    exact: true,
    name: 'Keka HR Integration',
    icon: 'ni ni-settings text-primary',
    component: KekaDetailPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().integrationsJira,
    exact: true,
    name: 'Jira Integration',
    icon: 'ni ni-settings text-primary',
    component: JiraDetailPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().integrationsSageHR,
    exact: true,
    name: 'Sage HR Integration',
    icon: 'ni ni-settings text-primary',
    component: SageHRDetailPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().integrationsZohoPeople,
    exact: true,
    name: 'Zoho People Integration',
    icon: 'ni ni-settings text-primary',
    component: ZohoPeopleDetailPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().downloadDesktopApp,
    exact: true,
    name: 'Download Desktop App',
    icon: 'ni ni-cloud-download-95 text-primary',
    component: DownloadDesktopAppPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().project,
    moduleId: moduleIds.PROJECTS,
    exact: true,
    name: 'Projects',
    icon: 'ni ni-tv-2 text-primary',
    component: ProjectPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().invites,
    exact: true,
    name: 'Invite',
    icon: 'ni ni-tv-2 text-primary',
    component: Invite,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().inviteesList,
    exact: true,
    name: 'InviteList',
    icon: 'ni ni-tv-2 text-primary',
    component: InviteesListPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().manageTasks,
    moduleId: moduleIds.TASKS,
    exact: true,
    name: 'Manage Tasks',
    icon: 'ni ni-tv-2 text-primary',
    component: ManageTasks,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().addTask,
    exact: true,
    name: 'Add Task',
    icon: 'ni ni-tv-2 text-primary',
    component: AddTaskPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().updateTask,
    exact: true,
    name: 'Update Task',
    icon: 'ni ni-tv-2 text-primary',
    component: AddUpdateTaskPage,
    authorizedFor: ['Manager', 'Admin'],
  },
  {
    path: appRoutes().profile,
    exact: true,
    name: 'Profile',
    icon: 'ni ni-tv-2 text-primary',
    component: ProfilePage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().regularization,
    moduleId: moduleIds.REGULARIZATION,
    exact: true,
    name: 'Regularization',
    icon: 'ni ni-tv-2 text-primary',
    component: RegularizationPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().requestsRegularization,
    moduleId: moduleIds.REQUESTS_REGULARIZATION,
    exact: true,
    name: 'Regularization Requests',
    icon: 'ni ni-tv-2 text-primary',
    component: RegularizationRequestsPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().leave,
    moduleId: moduleIds.LEAVE,
    exact: true,
    name: 'Leave',
    icon: 'ni ni-tv-2 text-primary',
    component: LeavePage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().requestsLeave,
    moduleId: moduleIds.LEAVE_REQUESTS,
    exact: true,
    name: 'Leave Requests',
    icon: 'ni ni-tv-2 text-primary',
    component: LeaveRequestPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().dashboardOverview,
    moduleId: moduleIds.DASHBOARD_OVERVIEW,
    exact: true,
    name: 'Dashboard Overview',
    icon: 'ni ni-tv-2 text-primary',
    component: DashboardOverviewPage,
    authorizedFor: ['Manager', 'Admin', 'Member'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().dashboardOverviewNew,
    moduleId: moduleIds.DASHBOARD_OVERVIEW,
    exact: true,
    name: 'Users Dashboard',
    subtitle: "A holistic view of your team's productivity and activities",
    icon: 'ni ni-tv-2 text-primary',
    component: DashboardOverviewNewPage,
    authorizedFor: ['Manager', 'Admin', 'Member'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().teamDashboard,
    exact: true,
    name: 'Teams Dashboard',
    subtitle: "A holistic view of your team's productivity and activities",
    icon: 'ni ni-tv-2 text-primary',
    component: TeamDashboardPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().onboarding,
    exact: true,
    name: 'Onboarding',
    icon: 'ni ni-tv-2 text-primary',
    component: OnboardingPage,
    authorizedFor: ['Manager', 'Admin'],
    hasSortingOptions: false,
  },
  {
    path: appRoutes().checkEmail,
    exact: true,
    name: 'Check Email',
    icon: 'ni ni-tv-2 text-primary',
    component: CheckEmailPage,
    authorizedFor: ['All'],
    hasSortingOptions: false,
  },
];

export const Router = ({ history = {} }) => {
  const planFeatures = useSelector((state) => state.planFeatures);
  const { hasAccess } = useFeatures();
  let filteredRoutesData = routesData;
  filteredRoutesData = filteredRoutesData.filter((route) => {
    if (route.moduleId && !planFeatures.loading) {
      return hasAccess.module(route.moduleId);
    }
    return true;
  });
  return (
    <ConnectedRouter history={history}>
      <IndexLayout>
        <Switch>
          <Route
            exact
            path="/"
            render={() => <Redirect to={appRoutes().dashboardOverview} />}
          />
          {filteredRoutesData.map((route) => (
            <Route
              path={route.path}
              component={route.component}
              key={route.path}
              exact={route.exact}
            />
          ))}
          <Route component={NotFoundPage} />
        </Switch>
      </IndexLayout>
    </ConnectedRouter>
  );
};
Router.propTypes = {
  history: PropTypes.instanceOf(Object),
};
